.body {
  display: flex;
  flex-direction: column;
  gap: var(--space__lg);
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space__sm);
}
